import { Tooltip as HeroUITooltip, type TooltipProps } from "@heroui/tooltip";

export function Tooltip(props: TooltipProps) {
  return <HeroUITooltip closeDelay={100} {...props} />;
}
